// frontend/src/components/common/SaveButton.js
import React from 'react';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import { useSaved } from '../../context/SavedContext';
import { useToast } from '../../context/ToastContext';

function SaveButton({ itemId, itemType, className = "" }) {
  const { isSaved, toggleSave } = useSaved();
  const { addToast } = useToast();
  const saved = isSaved(itemId);

  const handleClick = async (e) => {
    e.preventDefault(); 
    e.stopPropagation();
    
    const newState = await toggleSave(itemId, itemType);
    
    // Show Toast based on result
    if (newState) {
        addToast("Item saved to wishlist!", "success");
    } else {
        addToast("Item removed from wishlist.", "info");
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`p-2 rounded-full transition-all duration-200 shadow-sm ${
        saved 
          ? 'bg-red-50 text-red-500 hover:bg-red-100' 
          : 'bg-white text-gray-400 hover:text-red-500 hover:bg-gray-50'
      } ${className}`}
      title={saved ? "Remove from Saved" : "Save for Later"}
    >
      {saved ? <FaHeart /> : <FaRegHeart />}
    </button>
  );
}

export default SaveButton;